// extracted by mini-css-extract-plugin
export var nationalView = "nationalView-module--nationalView--LE58h";
export var impactSection = "nationalView-module--impactSection--9C4fO";
export var impactHeader = "nationalView-module--impactHeader--uU4UF";
export var impactCards = "nationalView-module--impactCards--LPfTl";
export var impactCard = "nationalView-module--impactCard--PCb+P";
export var circleWrap = "nationalView-module--circleWrap--1Tv-G";
export var slideUp = "nationalView-module--slideUp--5Adi7";
export var slideUpLarge = "nationalView-module--slideUpLarge--cgsV2";